import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=348089b8&scoped=true&"
import script from "./EventView.vue?vue&type=script&lang=js&"
export * from "./EventView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348089b8",
  null
  
)

export default component.exports